// components/FileUploader.tsx
import { useState, useEffect } from "react";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db, storage } from "../firebase/firebase";

interface Props {
  userId: string;
  agentId: string;
}

export default function FileUploader({ userId, agentId }: Props) {
  const [files, setFiles] = useState<any[]>([]);
  const [uploading, setUploading] = useState(false);

  const fetchFiles = async () => {
    const snap = await getDocs(
      collection(db, `users/${userId}/agents/${agentId}/files`)
    );
    const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setFiles(list);
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);

    const storageRef = ref(
      storage,
      `userFiles/${userId}/${Date.now()}_${file.name}`
    );
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);

    await addDoc(collection(db, `users/${userId}/agents/${agentId}/files`), {
      name: file.name,
      type: file.type,
      url,
      uploadedAt: Date.now(),
    });

    await fetchFiles();
    setUploading(false);
  };

  const handleDelete = async (file: any) => {
    const storageRef = ref(storage, `userFiles/${userId}/${file.name}`);
    await deleteObject(storageRef);
    await deleteDoc(
      doc(db, `users/${userId}/agents/${agentId}/files/${file.id}`)
    );
    await fetchFiles();
  };

  return (
    <div className="mt-4 bg-secondary p-4 rounded-lg text-offwhite">
      <h3 className="font-semibold mb-2">📂 Agent Files</h3>
      <input
        type="file"
        onChange={handleUpload}
        className="text-sm mb-4 text-offwhite"
        disabled={uploading}
      />
      <ul className="space-y-2 text-sm">
        {files.map((file) => (
          <li key={file.id} className="flex justify-between items-center">
            <a
              href={file.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal underline"
            >
              {file.name}
            </a>
            <button
              onClick={() => handleDelete(file)}
              className="text-red-500 text-xs hover:underline"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
